import api from "@/config/api";
import { API_ENDPOINTS } from "@/constants/api-endpoints";
import type {
  CommissionRateResponseDTO,
  CommissionRateRequestDTO,
  PaginatedResponse,
} from "../types/commission-rate.types";

export const commissionRateService = {
  listPaginated: async (params: {
    page?: number;
    size?: number;
  }): Promise<PaginatedResponse<CommissionRateResponseDTO>> => {
    const response = await api.get<
      PaginatedResponse<CommissionRateResponseDTO>
    >(API_ENDPOINTS.COMMISSION_RATES.PAGINATED, { params });
    return response.data;
  },

  create: async (
    data: CommissionRateRequestDTO,
  ): Promise<CommissionRateResponseDTO> => {
    const response = await api.post<CommissionRateResponseDTO>(
      API_ENDPOINTS.COMMISSION_RATES.BASE,
      data,
    );
    return response.data;
  },

  update: async (
    id: number,
    data: CommissionRateRequestDTO,
  ): Promise<CommissionRateResponseDTO> => {
    const response = await api.put<CommissionRateResponseDTO>(
      API_ENDPOINTS.COMMISSION_RATES.BY_ID(id),
      data,
    );
    return response.data;
  },

  remove: async (id: number): Promise<void> => {
    await api.delete(API_ENDPOINTS.COMMISSION_RATES.BY_ID(id));
  },
};
